(function($, undefined) {
	'use strict';
	var headerCom;
	var checkout;
	var utils;
	
	function toggleCart() {
		if ($('body').hasClass('cart-open')) {
			closeCart();
		} else {
			openCart();
		}
	}
	
	function openCart(callback) {
		var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
		
		$('.cart').on(transitionEnd, function(e) {
			$(document).on('click', outsideClickCart);
			$('.cart').off(transitionEnd);
			
			if (typeof callback === 'function') {
				callback();
			}
		});
		
		$('.cart').addClass('open');
		$('body').addClass('cart-open');
		headerCom.removeScroll();
	}
	
	function closeCart() {
		$('.cart').removeClass('open');
		$('body').removeClass('cart-open');
		$(document).off('click', outsideClickCart);
		headerCom.applyScroll();
	}
	
	function outsideClickCart(event) {
		if (!$(event.target).closest('.cart').length) {
			closeCart();
		}
	}
	
	function cardAddCart () {
		var t = $(this);
		var item = t.closest('.shop-product');
		var qty = 1;
		
		processAddCart({
			id: item.attr('data-id'),
			isbn: item.attr('data-isbn'),
			authors: item.attr('data-authors'),
			qty: qty
		});
	}
	
	function detailAddCart() {
		var t = $(this);
		var item = t.closest('.product-detail');
		var chosenOption = t.closest('.options-table-ctn').find('.product-detail-item-choice:checked');
		var data = {
			id: item.attr('data-id'),
			isbn: item.attr('data-isbn'),
			authors: item.attr('data-authors'),
			qty: 1
		};

		if (chosenOption.hasClass('product-set')) {
			data.setIds = chosenOption.val();
		}

		processAddCart(data);
	}
	
	function processAddCart (params) {
		var qty = parseInt(params.qty);
		var cartData = {
			ids: params.id,
			quantities: qty,
			getCart: true
		};
		var setId = '[data-set-id=""]';

		if (params.setIds) {
			cartData.setIds = params.setIds;
			setId = `[data-set-id="${params.setIds}"]`;
		}

		footerProcessing();

		$.ajax({
			url: '/action/ajaxAddCart',
			cache: false,
			data: cartData,
			success: function (response) {
				updatePrice(response);
				updateBtns(params.id);
				handleCartItems(response, params.authors, params.isbn);
				updateCount();
		
				openCart(function () {
					var currentCartItem = $(`.cart-item[data-product-id="${params.id}"]${setId}`);
					var target = currentCartItem.position().top;
					
					$('.cart__content').animate({scrollTop: target}, 500, function () {
						currentCartItem.addClass('standing');
						
						setTimeout(function () {
							currentCartItem.removeClass('standing');
						}, 500);
					});
				});
			}
		});
	}

	function handleCartItems(cartData, authors, isbn) {
		if (cartData) {
			cartData = typeof cartData == "string" ? JSON.parse(cartData) : cartData;
			var products = cartData[0];
			var cartPopup = $('.cart__content');
			var cartItems = $('.cart-item:not(.clone)', cartPopup);

			for (var k in products) {
				var cartItemData = products[k];
				var currentCartItem = cartItems.filter("[data-id=" + cartItemData.id + "]");
				if (currentCartItem.length === 0) {
					var clone = createCartPopupItem(cartItemData, '.cart-item.clone', authors, isbn);
					clone.hide();
					cartPopup.append(clone);
					clone.slideDown();
				} else {
					updateCartItemUi(cartItemData, currentCartItem, authors, isbn);
				}
			}
		}
	}

	function createCartPopupItem(cartItemData, templateItem, authors = '', isbn = '') {
		var cartItemTemplate = $(templateItem).clone(true);
		cartItemTemplate.removeClass('clone');

		updateCartItemUi(cartItemData, cartItemTemplate, authors, isbn);

		return cartItemTemplate;
	}

	function updateCartItemUi(cartItemData, cartItem, authors = '', isbn = '') {
		var currItemId = cartItem.attr('data-id');
		var name = utils.decodeText(cartItemData.name);
		var description = utils.decodeText(cartItemData.shortDescription);
		var authorsEl = $('.cart-item__info[data-info="author"] .cart-item__info_val', cartItem);
		var isbnEl = $('.cart-item__info[data-info="isbn"] .cart-item__info_val', cartItem);

		$('.cart-item__price-unit', cartItem).attr('data-price', cartItemData.price);
		$('.cart-item__price-total', cartItem).html(utils.formatNumberToMoney(cartItemData.price));
		$('.cart-qty-input', cartItem).val(cartItemData.quantity);
		$('.cart-qty-input', cartItem).attr('data-default', cartItemData.quantity);

		// update following info if new item only 
		if (currItemId === '') {
			cartItem.attr('data-id', cartItemData.id);
			cartItem.attr('data-product-id', cartItemData.productId);
			if (cartItemData.productSetInfos) {
				if (cartItemData.productSetInfos.id) {
					cartItem.attr('data-set-id', cartItemData.productSetInfos.id);
				}
				if (cartItemData.productSetInfos.name) {
					name += ' - ' + utils.decodeText(cartItemData.productSetInfos.name);
				}
			}
			$('.cart-item__title', cartItem).html(name);
			$('.cart-item__desc', cartItem).html(description);
			$('.cart-item__image img', cartItem).attr('src', '/static/uploaded/Catalog/'+cartItemData.mediaId+'-preview.jpg');
			$('.cart-item__image img', cartItem).attr('alt', name);
			$('.cart-item__price-unit_val', cartItem).html(utils.formatNumberToMoney(cartItemData.unitPrice));
			if (authors.length !== 0 || isbn.length !== 0) {
				authors.length !== 0 ? authorsEl.html(authors) : authorsEl.hide();
				isbn.length !== 0 ? isbnEl.html(isbn) : isbnEl.hide();
			} else {
				$('.cart-item__toggle-detail', cartItem).addClass('cart-item__toggle-detail_invisible');
			}
		}
	}

	function updateBtns(id) {
		$('.product-detail[data-id=' + id + ']').find('.qty-input').val(1).trigger('keyup');
	}
	
	function changeQty () {
		var t = $(this);

		setTimeout(function() {
			checkDiffQty.apply(t);
		}, 100);
	}
	
	function checkDiffQty() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var input = $('.cart-qty-input', item);
		var defaultVal = parseInt(input.attr('data-default'));
		var currCount = parseInt(input.val());

		updateBtns(item.attr('data-id'));
		
		if (currCount !== defaultVal) {
			$('.cart-item__price-update', item).addClass('show');
		} else {
			$('.cart-item__price-update', item).removeClass('show');
		}
	}
	
	function submitQtyChange() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var id = item.attr('data-id');
		var input = $('.cart-qty-input', item);
		var currCount = parseInt(input.val());
		input.attr('data-default', currCount);
		$('.cart-item__price-update', item).removeClass('show');
		updateItemPrice(item, currCount);
		updateCount();
		footerProcessing();
		
		$.ajax({
			url: '/action/ajaxAddCart',
			cache: false,
			data: {
				ids: item.attr('data-id'),
				quantities: currCount,
				getCart: true,
				override: true
			},
			success: function (response) {
				if (currCount === 0) {
					$('.cart-item[data-id='+ id +']').slideUp(function() {
						$(this).remove();
					});
				}
				updatePrice(response);
				updateBtns(item.attr('data-id'));
				if ($('.checkout__recap').length > 0) {
					checkout.updateRecap();
				}
			}
		});
	}

	var updateItemPrice = function(item, qty) {
		var unitPrice = parseFloat($('.cart-item__price-unit', item).attr('data-price'));
		$('.cart-item__price-total', item).text(formatMoney(unitPrice * qty));
	};
	
	function cancelQtyChange() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var input = $('.cart-qty-input', item);
		var defaultVal = parseInt(input.attr('data-default'));
		
		input.val(defaultVal);
		checkDiffQty.apply(input);
	}
	
	function deleteItem() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var data = {
			ids: item.attr('data-id'),
			quantities : 0,
			getCart: true,
			override: true
		};

		if (item.attr('data-set-id') && item.attr('data-set-id').length > 0) {
			data.setIds = item.attr('data-set-id');
		}
		
		footerProcessing();
		$.ajax({
			url: '/action/ajaxAddCart',
			cache: false,
			data: data,
			success: function (response) {
				updateBtns(item.attr('data-id'));
				item.slideUp(300, function () {
					item.remove();
					updateCount();
				});
				updatePrice(response);
			}
		});
	}
	
	function updateCount() {
		var count = 0;
		$('.cart-item:not(.clone) .cart-qty-input').each(function () {
			count += parseInt(this.value);
		});
		
		$('.cart__header_title-count, .header__cart span').text(count);
	}
	
	function updatePrice(response) {
		var cartJson = typeof response === 'object' ? response : JSON.parse(response);
        var cartInfo = cartJson[cartJson.length - 1];
        var promoAmt = cartInfo.promoAmount;
        
		$('.cart__footer-review').removeClass('is-processing');
		$('.cart__subtotal').text(formatMoney(cartInfo.subtotal));
		$('.cart__total').text(formatMoney(cartInfo.subtotalWithPromo));
        if (promoAmt !== '0.00' && promoAmt !== '0,00') {
            $('.cart__promo').html('-' + formatMoney(promoAmt));
        } else {
            $('.cart__promo').html(formatMoney(0));
        }
	}
	
	function footerProcessing() {
		$('.cart__footer-review').addClass('is-processing');
	}
	
	var init = function() {
		headerCom = Fw.modules.models().header;
		checkout = Fw.component.models().checkout;
		utils = Fw.component.models().utils;
		
		$('body').on('click', '.cart-item__toggle-detail', function () {
			var item = $(this).closest('.cart-item');
			$('.cart-item__info-ctn', item).slideToggle(200);
			item.toggleClass('open-info');
		});

		$('body').on('click', '.cart-change-qty-btn.minus, .cart-change-qty-btn.plus', changeQty);
		$('body').on('input', '.cart-qty-input', checkDiffQty);
		$('body').on('click', '.cart-item__price-update_btn', submitQtyChange);
		$('body').on('click', '.cart-item__price-update_cancel-btn', cancelQtyChange);
		$('body').on('click', '.cart-item__delete-btn', deleteItem);
		
		$('.btn-add-cart').click(cardAddCart);
		$('.product-detail__add-to-cart-btn').click(detailAddCart);
	};
	
	$(init);
	
	Fw.modules.export('cart', {
		toggleCart,
		openCart,
		closeCart,
		cardAddCart
	});
	
})(jQuery);
